export default "__VITE_ASSET__54a2df91__"